// extracted by mini-css-extract-plugin
export default {"root":"ReplyingTo-root-cfeac48619aee7b90b242246c7afece2","text":"ReplyingTo-text-e3bed2f56c4da2d43423c1225bf226d6","username":"ReplyingTo-username-b057af1333a82b725f15d6673fb0748f"};